import {
  GET_CONTACT_LIST,
  GET_CONTACT_LIST_DETAIL_FAIL,
  GET_CONTACT_LIST_DETAIL_SUCCESS,
  GET_CONTACT_LIST_FAIL,
  GET_CONTACT_LIST_SUCCESS,
} from "./actionTypes"

const INIT_STATE = {
  contactLists: [],
  contactListsTotal: 0,
  contactListsTotalPages: 0,
  contactDetailList: [],
  contactDetailTotal: 0,
  contactDetailTotalPages: 0,
  userProfile: {},
  error: {},
  loading: true
}

const contactLists = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_CONTACT_LIST_SUCCESS:
      // payload is { rows, total, totalPages } (or a bare array, back-compat).
      return {
        ...state,
        contactLists: Array.isArray(action.payload) ? action.payload : action.payload.rows,
        contactListsTotal: Array.isArray(action.payload) ? action.payload.length : action.payload.total ?? 0,
        contactListsTotalPages: Array.isArray(action.payload) ? 1 : action.payload.totalPages ?? 0,
        loading: true
      }

    case GET_CONTACT_LIST_DETAIL_SUCCESS:
      // payload is { rows, total, totalPages } (or a bare array, back-compat).
      return {
        ...state,
        contactDetailList: Array.isArray(action.payload) ? action.payload : action.payload.rows,
        contactDetailTotal: Array.isArray(action.payload) ? action.payload.length : action.payload.total ?? 0,
        contactDetailTotalPages: Array.isArray(action.payload) ? 1 : action.payload.totalPages ?? 0,
        loading: false
      }

    case GET_CONTACT_LIST_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_CONTACT_LIST_DETAIL_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    // case ADD_USER_SUCCESS:

    //   return {
    //     ...state,
    //     users: [action.payload, ...state.users],
    //   }

    // case ADD_USER_FAIL:
    //   return {
    //     ...state,
    //     error: action.payload,
    //   }

    // case GET_USER_PROFILE_SUCCESS:
    //   return {
    //     ...state,
    //     userProfile: action.payload,
    //   }

    // case UPDATE_USER_SUCCESS:
    //   return {
    //     ...state,
    //     users: state.users.map(user =>
    //       user.id.toString() === action.payload.id.toString()
    //         ? { user, ...action.payload }
    //         : user
    //     ),
    //   }

    // case UPDATE_USER_FAIL:
    //   return {
    //     ...state,
    //     error: action.payload,
    //   }

    // case DELETE_USER_SUCCESS:
    //   return {
    //     ...state,
    //     users: state.users.filter(
    //       user => user.id.toString() !== action.payload.toString()
    //     ),
    //   }

    // case DELETE_USER_FAIL:
    //   return {
    //     ...state,
    //     error: action.payload,
    //   }

    // case GET_USER_PROFILE_FAIL:
    //   return {
    //     ...state,
    //     error: action.payload,
    //   }

    default:
      return state
  }
}

export default contactLists
